export const ru = {
    assign_assistant: 'Назначить ассистента',
};
